.redirect-phone-form {
    display: flex;
    flex-direction: column;
    padding: 16px;
    box-sizing: border-box;
    justify-content: space-between;
    /* Provides for the height of the top bar and the delete button */
    height: calc(100% - 64px);
}
